import state from './stickerState';
import mutations from './stickerMutations';
import getters from './stickerGetters';
import actions from './stickerActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
